import createIcon from '../../createIcon';

/**
 * @component @name Forward30
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTggMTRDMTggMTcuMzEgMTUuMzEgMjAgMTIgMjBDOC42OSAyMCA2IDE3LjMxIDYgMTRDNiAxMC42OSA4LjY5IDggMTIgOFYxMkwxNyA3TDEyIDJWNkM3LjU4IDYgNCA5LjU4IDQgMTRDNCAxOC40MiA3LjU4IDIyIDEyIDIyQzE2LjQyIDIyIDIwIDE4LjQyIDIwIDE0SDE4WiIgZmlsbD0iYmxhY2siLz4KPHBhdGggZD0iTTEwLjA2IDE2LjM4QzkuNzcgMTYuMzggOS40NCAxNi4yMSA5LjQ0IDE1Ljg0SDguNTlDOC41OSAxNi44MSA5LjQ5IDE3LjA3IDEwLjA0IDE3LjA3QzEwLjkxIDE3LjA3IDExLjU1IDE2LjYxIDExLjU1IDE1LjgyQzExLjU1IDE1LjE2IDExLjEgMTQuOTIgMTAuODQgMTQuODJDMTAuOTUgMTQuNzcgMTEuNDkgMTQuNSAxMS40OSAxMy45QzExLjQ5IDEzLjY5IDExLjQ0IDEyLjY4IDEwLjA1IDEyLjY4QzkuNDMgMTIuNjggOC42NSAxMy4wMyA4LjY1IDEzLjg0SDkuNUM5LjUgMTMuNSA5LjgxIDEzLjM2IDEwLjA3IDEzLjM2QzEwLjY2IDEzLjM2IDEwLjY1IDEzLjg2IDEwLjY1IDEzLjlDMTAuNjUgMTQuNDIgMTAuMjQgMTQuNDkgMTAuMDIgMTQuNDlIOS41NlYxNS4xNUgxMC4wMUMxMC42NiAxNS4xNSAxMC43MSAxNS41NyAxMC43MSAxNS43OUMxMC43MSAxNi4xMSAxMC41IDE2LjM4IDEwLjA2IDE2LjM4WiIgZmlsbD0iYmxhY2siLz4KPHBhdGggZD0iTTEzLjg1IDEyLjY4QzEzLjcxIDEyLjY4IDEyLjQxIDEyLjYgMTIuNDEgMTQuNVYxNS4yNEMxMi40MSAxNy4xNCAxMy43MiAxNy4wNiAxMy44NSAxNy4wNkMxMy45OSAxNy4wNiAxNS4yOSAxNy4xNSAxNS4yOSAxNS4yNFYxNC41QzE1LjMgMTIuNTkgMTMuOTkgMTIuNjggMTMuODUgMTIuNjhaTTE0LjQ1IDE1LjM1QzE0LjQ1IDE2LjEyIDE0LjI0IDE2LjM4IDEzLjg2IDE2LjM4QzEzLjQ4IDE2LjM4IDEzLjI2IDE2LjEyIDEzLjI2IDE1LjM1VjE0LjM4QzEzLjI2IDEzLjYzIDEzLjQ4IDEzLjM3IDEzLjg1IDEzLjM3QzE0LjIzIDEzLjM3IDE0LjQ1IDEzLjYzIDE0LjQ1IDE0LjM4VjE1LjM1WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Forward30 = createIcon('Forward30', [
  [
    'path',
    {
      d: 'M18 14C18 17.31 15.31 20 12 20C8.69 20 6 17.31 6 14C6 10.69 8.69 8 12 8V12L17 7L12 2V6C7.58 6 4 9.58 4 14C4 18.42 7.58 22 12 22C16.42 22 20 18.42 20 14H18Z',
      key: '1ldjgn',
    },
  ],
  [
    'path',
    {
      d: 'M10.06 16.38C9.77 16.38 9.44 16.21 9.44 15.84H8.59C8.59 16.81 9.49 17.07 10.04 17.07C10.91 17.07 11.55 16.61 11.55 15.82C11.55 15.16 11.1 14.92 10.84 14.82C10.95 14.77 11.49 14.5 11.49 13.9C11.49 13.69 11.44 12.68 10.05 12.68C9.43 12.68 8.65 13.03 8.65 13.84H9.5C9.5 13.5 9.81 13.36 10.07 13.36C10.66 13.36 10.65 13.86 10.65 13.9C10.65 14.42 10.24 14.49 10.02 14.49H9.56V15.15H10.01C10.66 15.15 10.71 15.57 10.71 15.79C10.71 16.11 10.5 16.38 10.06 16.38Z',
      key: '1u42p9',
    },
  ],
  [
    'path',
    {
      d: 'M13.85 12.68C13.71 12.68 12.41 12.6 12.41 14.5V15.24C12.41 17.14 13.72 17.06 13.85 17.06C13.99 17.06 15.29 17.15 15.29 15.24V14.5C15.3 12.59 13.99 12.68 13.85 12.68ZM14.45 15.35C14.45 16.12 14.24 16.38 13.86 16.38C13.48 16.38 13.26 16.12 13.26 15.35V14.38C13.26 13.63 13.48 13.37 13.85 13.37C14.23 13.37 14.45 13.63 14.45 14.38V15.35Z',
      key: '1r8fsf',
    },
  ],
]);

export default Forward30;
